module.exports = __webpack_public_path__ + "static/media/day03.7c0f528a.jpg";